export const trackMetaPixelRegistration = () => {
  // Inject Meta Pixel script tag
  const script = document.createElement("script");
  script.textContent = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1012736364375950');
    fbq('track', 'PageView');
    fbq('track', 'CompleteRegistration', {
      content_name: 'DocMaster School Registration',
      status: true
    });
  `;
  document.head.appendChild(script);

  // Inject noscript fallback image
  const noscript = document.createElement("noscript");
  const img = document.createElement("img");
  img.height = "1";
  img.width = "1";
  img.style.display = "none";
  img.src =
    "https://www.facebook.com/tr?id=1012736364375950&ev=PageView&noscript=1";
  noscript.appendChild(img);
  document.body.appendChild(noscript);

  console.log(
    "✅ Meta Pixel fired: CompleteRegistration event sent successfully",
  );
};
